@if ((dismissed$ | async) === false) {
    <div [class]="ctaBackgroundStyle">
        <div class="cta-wrapper">
            <img class="cta-image"
                 [src]="ctaImage"
                 alt="Happy guy" />

            <div class="cta-body">
                <div class="cta-title">
                    <ng-container [ngTemplateOutlet]="projectedTitleContent"></ng-container>
                </div>
                <div class="cta-content">
                    <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
                </div>
            </div>

            <div class="cta-action">
                <ng-container [ngTemplateOutlet]="projectedActionContent"></ng-container>
            </div>
        </div>

        <button adaptButton="closeBorderless"
                adaptTooltip="Dismiss"
                class="cta-dismiss"
                (click)="dismiss()"></button>
    </div>
}

<ng-template #projectedContent>
    <ng-content></ng-content>
</ng-template>

<ng-template #projectedTitleContent>
    <ng-content select="[adapt-cta-title]"></ng-content>
</ng-template>

<ng-template #projectedActionContent>
    <ng-content select="[adapt-cta-action]"></ng-content>
</ng-template>
